import { api } from "../../api/endpoints";
import toast from "react-hot-toast";
import {
  ADD_APK,
  ADD_APK_SUCCESS,
  APK_ALREADY_SAVED,
  APK_DELETE,
  APK_FLAG_OFF,
  APK_INDENTITY,
  FETCH_APK_REQUEST,
  FETCH_APK_SUCCESS,
  GET_LATEST_APK,
} from "../constant";
export const apkFlagOff = () => {
  return async (dispatch) => {
    dispatch({
      type: APK_FLAG_OFF,
      payload: "",
    });
  };
};
const putFileToS3 = (url, file, onProgress) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url, true);
    xhr.setRequestHeader("Content-Type", "application/vnd.android.package-archive");
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        onProgress?.(Math.round((event.loaded / event.total) * 100));
      }
    };
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`));
    xhr.onerror = () => reject(new Error("Network error during upload"));
    xhr.send(file);
  });

export const apkUpload = (file, onProgress) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_APK,
      payload: ''
    })
    try {
      const { data: presigned } = await api.post(`/apk/presignedurl`, { fileName: file.name });
      await putFileToS3(presigned.url, file, onProgress);
      const apk = await api.post(`/apk/apkfile`, { path: presigned.filename, originalName: file.name });
      if (apk.status === 201) {
        if (apk.data.required) {
          if (apk.data.isAlreadyAvailable) {
            dispatch({
              type: APK_ALREADY_SAVED,
              payload: "",
            });
          } else {
            dispatch({
              type: ADD_APK_SUCCESS,
              payload: apk.data.apk,
            });
          }
        } else {
          dispatch({
            type: APK_INDENTITY,
            payload: ''
          })
        }
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || error?.response?.data || error?.message || "Upload failed");
      dispatch({ type: APK_FLAG_OFF, payload: "" });
    }
  };
};
export const fetchApk = () => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_APK_REQUEST,
      payload: "",
    });
    const { status, data } = await api.get(`/apk/getapk`);
    if (status === 200) {
      dispatch({
        type: FETCH_APK_SUCCESS,
        payload: data.apk,
      });
    }
  };
};
export const apkDelete = (id) => {
  return async (dispatch) => {
    const apk = await api.get(`/apk/deleteapk/${id}`);
    if (apk.status === 201) {
      dispatch({
        type: APK_DELETE,
        payload: id,
      });
    }
  };
};

export const getLatestApks = () => {
  return async (dispatch) => {
    try {
      const {data, status} = await api.get('/apk/getLatestApks')
      dispatch({
        type: GET_LATEST_APK,
        payload: data.versions
      })
    } catch (error) {
      
    }
  }
}
